import { Controller } from "@hotwired/stimulus"

// A tab-local, account-bound draft, never credentials or a server submission.
// Native/game forms do not opt in. Revision changes retire obsolete consent.
export default class extends Controller {
  static values = { owner: String, kind: String, revision: String }

  connect() {
    this.key = `vending.public-draft.${this.ownerValue}.${this.kindValue}`
    this.saveBound = () => this.save()
    this.clearBound = () => { this.finished = true }
    this.restore()
    window.addEventListener("pagehide", this.saveBound)
    window.addEventListener("public-drafts:clear", this.clearBound)
  }

  disconnect() {
    window.removeEventListener("pagehide", this.saveBound)
    window.removeEventListener("public-drafts:clear", this.clearBound)
  }

  fields() {
    return Array.from(this.element.querySelectorAll("textarea[name], input[name], select[name]"))
      .filter(field => ["feedback_body", "review_body", "review_display_name", "terms", "consent", "opt_in", "installation"].includes(field.name))
  }

  save() {
    if (this.finished) return
    try {
      const values = Object.fromEntries(this.fields().map(field =>
        [field.name, field.type === "checkbox" ? field.checked : field.value]))
      sessionStorage.setItem(this.key, JSON.stringify({ revision: this.revisionValue, values }))
    } catch { /* Disabled/full storage must not block ordinary form use. */ }
  }

  restore() {
    try {
      const draft = JSON.parse(sessionStorage.getItem(this.key))
      if (!draft || draft.revision !== this.revisionValue) {
        sessionStorage.removeItem(this.key)
        return
      }
      this.fields().forEach(field => {
        const value = draft.values[field.name]
        if (field.type === "checkbox") field.checked = value === true
        else if (typeof value === "string") field.value = value.slice(0, field.maxLength > 0 ? field.maxLength : 5000)
      })
    } catch { /* A malformed or inaccessible draft must not break the editor. */ }
  }

  submitted(event) {
    const response = event.detail.fetchResponse?.response
    if (!event.detail.success || !response) return
    const path = new URL(response.url).pathname
    // An expired session redirect is NOT successful draft submission.
    if (!path.startsWith("/vending-empire/testing/")) return
    this.finished = true
    try { sessionStorage.removeItem(this.key) } catch { /* Storage may be disabled. */ }
  }
}
